import { render, staticRenderFns } from "./myAdvisory.vue?vue&type=template&id=0e18c1cc&scoped=true"
import script from "./myAdvisory.vue?vue&type=script&lang=js"
export * from "./myAdvisory.vue?vue&type=script&lang=js"
import style0 from "./myAdvisory.vue?vue&type=style&index=0&id=0e18c1cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e18c1cc",
  null
  
)

export default component.exports